// 変更履歴（何をしたかだけ。中身は持たないので、この単位では戻せない。戻すのは区切りから）。
// undo / redo も、何を取り消した・やり直したかを付けて残す（docs/edit-history-undo.md）。
// 続けて同じ対象に同じ操作をしたら 1 件にまとめ（ボタンを 10 回うごかしたら ×10）、数秒ごとにまとめて送る。
// エディタを閉じる・こうかいを こうしんの前に flushEditHistory で送り切る
import throttle from "lodash-es/throttle";
import { appendProjectEditHistory } from "features/creator/api";
import { ProjectEditAction, ProjectEditHistoryEntry } from "features/creator/types";

type Entry = Omit<ProjectEditHistoryEntry, "id" | "created_at">;

/** api が 1 回に受け付ける件数 */
const MAX_ENTRIES = 100;

let pending: { uid: string; project_id: string; entries: Entry[] } | null = null;

const send = async () => {
  if (!pending || pending.entries.length === 0) return;
  const batch = pending;
  pending = null;
  // 履歴が送れなくても編集は止めない
  await appendProjectEditHistory(batch).catch(() => undefined);
};

const throttledSend = throttle(send, 5000, { leading: false });

export const recordEditHistory = (
  uid: string,
  project_id: string,
  entry: {
    action_type: ProjectEditAction;
    undone_action_type?: ProjectEditAction | null;
    target_type?: string | null;
    target_name?: string | null;
    count?: number;
  },
) => {
  if (!uid || !project_id) return;
  // 別のアプリに移ったら、前のアプリの分は先に送る
  if (pending && pending.project_id !== project_id) void send();
  if (!pending) pending = { uid, project_id, entries: [] };

  const next: Entry = {
    action_type: entry.action_type,
    undone_action_type: entry.undone_action_type ?? null,
    target_type: entry.target_type ?? null,
    target_name: entry.target_name ?? null,
    count: entry.count ?? 1,
  };
  const last = pending.entries[pending.entries.length - 1];
  if (
    last &&
    last.action_type === next.action_type &&
    last.undone_action_type === next.undone_action_type &&
    last.target_type === next.target_type &&
    last.target_name === next.target_name
  ) {
    last.count += next.count;
  } else {
    pending.entries.push(next);
  }
  if (pending.entries.length >= MAX_ENTRIES) {
    void send();
    return;
  }
  throttledSend();
};

export const flushEditHistory = async () => {
  throttledSend.cancel();
  await send();
};
